// extracted by mini-css-extract-plugin
export default {"container":"LinkExpiredPage_container__mzar6","description":"LinkExpiredPage_description__Kg3yT","buttonContainer":"LinkExpiredPage_buttonContainer__xNmnJ"};